<template>
    <div :class="$style.container">
        <ul :class="$style.top">
            <li v-for="(item, index) in tags" :key="item"
                :class="index === (tags.length -1) ? $style.active: ''"
            >{{item}}
                <i :class="['iconfont', 'icon-rightarrow2f', $style.arrow]"
                   v-if="index < (tags.length -1)"
                ></i>
            </li>
        </ul>
        <h4 :class="$style.title">
            <p :class="$style.name"> {{title}}</p>

            <div style="margin-bottom: 10px">
                <el-button :type="cusSubmit" @click.stop="handleSubmitClick" v-if="btnSubmit" size="small" :disabled="disabled">提交</el-button>
                <el-button :type="cusApproval" @click.stop="handleApprovalClick" v-if="btnApproval" size="small" :disabled="disabled">审批</el-button>
                <el-button :type="cusRecall" @click.stop="handleRecallClick" v-if="btnRecall" size="small" :disabled="disabled">撤回</el-button>
                <el-button type="success" @click.stop="handleAgreeClick" v-if="btnAgree" size="small" :disabled="disabled">同意</el-button>
                <el-button type="danger" @click.stop="handleRefuseClick" v-if="btnRefuse" size="small" :disabled="disabled">拒绝</el-button>
                <el-button :type="cusSave" @click.stop="handleSaveClick" v-if="btnSave" size="small" >保存</el-button>
                <el-button type="success" @click.stop="handleCompletedClick" v-if="btnCompleted" size="small" >完成</el-button>
                <el-button type="danger" @click.stop="handleRepealClick" v-if="btnRepeal" :disabled="boolRepeal" size="small" id="delete" class="icon">
                    <i :class="['iconfont', 'el-icon-error', $style.back]" style="position: relative;top:1px"></i>
                    删除
                </el-button>
                <el-button type="warning" @click.stop="handleCalculateDataClick" v-if="btnCalculateData" size="small" :disabled="disabled">重新计算统计数据</el-button>
                <el-button type="success" @click.stop="handleAddClick" v-if="btnAdd" size="small" class="icon">
                    <i :class="['iconfont', 'el-icon-plus', $style.back]" style="position: relative;top:1px"></i>
                    新增</el-button>
                <el-button type="danger" @click.stop="handleBackClick" v-if="btnBack" size="small" style="margin-left:30px" class="icon">
                    <i :class="['iconfont', 'icon-back', $style.back]" style="position: relative;top:1px"></i>
                    返回</el-button>
            </div>
        </h4>
        <div :class="$style.box">
            <div :class="$style.boxContent">
                <p :class="$style.level"><span v-if="institution_grade" style="margin-right: 20px">{{institution_grade}}</span><span :class="$style.site">{{address}}</span></p>
                <p :class="$style.level"><span :class="$style.clientele">目标客户{{target_num}}人</span><span :class="$style.clientele2">当月覆盖{{cover_num}}人</span></p>
            </div>
            <el-row :class="$style.dataStatus">
                <el-col style="width: 130px">
                     <span>
                     {{date}}
                    </span>
                </el-col>
                <el-col style="width: calc(100% - 140px)">
                    <ul class="hospital_ul">
                        <li class="" style="" v-for="item,i in checkInArr">
                        <span style="display: inline-block;width: 130px" :style="{'color':item.checkin_time ? '#FF9901' : '#ED3B3F'}">
                            {{ item | filterCheckIn }}
                        </span>
                        <span style="display: inline-block;width: 130px;" :style="{'color':item.checkout_time ? '#FF9901' : '#ED3B3F'}">
                            {{ item | filterCheckOut}}
                        </span>
                        </li>
                    </ul>
                    <ul class="hospital_ul">
                        <li v-if="checkInArr.length === 0">
                        <span style="display: inline-block;color: #ED3B3F">
                            尚未签入
                        </span>
                            <span style="display: inline-block;color: #ED3B3F">
                            尚未签出
                        </span>
                        </li>
                    </ul>
                </el-col>

            </el-row>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        props: {
            tags: {
                type: Array,
                default: () => []
            },
            title: {
                type: String,
                default: ''
            },
            date:{
                type: String,
                default: ''
            },
            institution_grade:{
                type: String,
                default: ''
            },
            address:{
                type: String,
                default: ''
            },
            target_num:{
                type: String,
                default: ''
            },
            cover_num:{
                type: String,
                default: ''
            },
            subTitle1: {
                type: String,
                default: ''
            },
            subTitle2: {
                type: String,
                default: ''
            },
            cusApproval: {
                type: String,
                default: 'info'
            },
            cusSubmit: {
                type: String,
                default: 'info'
            },
            cusRecall: {
                type: String,
                default: 'info'
            },
            cusSave: {
                type: String,
                default: 'primary'
            },
            boolSave:{
                type: Boolean,
                default: true
            },
            boolRepeal:{
                type: Boolean,
                default: true
            },
            btnSubmit: {
                type: Boolean,
                default: false
            },
            btnApproval: {
                type: Boolean,
                default: false
            },
            btnRecall: {
                type: Boolean,
                default: false
            },
            btnAgree: {
                type: Boolean,
                default: false
            },
            btnRefuse: {
                type: Boolean,
                default: false
            },
            btnRepeal: {
                type: Boolean,
                default: false
            },
            btnSave: {
                type: Boolean,
                default: false
            },
            btnBack: {
                type: Boolean,
                default: false
            },
            btnAdd: {
                type: Boolean,
                default: false
            },
            btnCalculateData: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                defalut: false
            },
            checkInArr: {
                type: Array,
                dafault:[]
            },
            btnCompleted: {
                type: Boolean,
                default: false
            },

        },
        updated(){

        },
        watch:{
            checkInArr(){

            }
        },
        filters:{
            filterCheckIn:function (item) {
                if (item.checkin_time){
                    return '签入：' + moment(item.checkin_time).format('HH:mm:ss')
                }
            },
            filterCheckOut:function (item) {
                if (item.checkout_time) {
                    return '签出：' + moment(item.checkout_time).format('HH:mm:ss')
                }else {
                    return '尚未签出'
                }
            },
            filterDate:function (item) {
                return moment(item).format('YYYY年M月D日')
            }
        },
        methods: {
            handleSubmitClick () {
                this.$emit('btnSubmitClick')
            },
            handleApprovalClick () {
                this.$emit('btnApprovalClick')
            },
            handleRecallClick () {
                this.$emit('btnRecallClick')
            },
            handleAgreeClick () {
                this.$emit('btnAgreeClick')
            },
            handleRefuseClick () {
                this.$emit('btnRefuseClick')
            },
            handleRepealClick () {
                this.$emit('btnRepealClick')
            },
            handleSaveClick () {
                this.$emit('btnSaveClick')
            },
            handleCalculateDataClick () {
                this.$emit('btnCalculateDataClick')
            },
            handleBackClick () {
                this.$emit('btnBackClick')
            },
            handleAddClick (){
                this.$emit('btnAddClick')
            },
            handleCompletedClick (){
                this.$emit('btnCompletedClick')
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../assets/css/default';
    .container {
        .top {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            li {
                color:#000000;
                text-align:left;
                font-size: $TopTitleFontSize;
                .arrow {
                    font-size: $TopTitleFontSize;
                    color: #babac2;
                    vertical-align: bottom;
                }
            }
            .active {
                color: #59a8f9;
            }
        }
        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            font-size:$TopSubFontSize;
            color:#000000;
            text-align:left;
            margin: 0;
            /*border-bottom:2px dotted #e7eaec;*/
            .name {
                color: #3b99f7;
                display: inline-block;
                font-size: 20px;
                margin-top: 20px;
                margin-bottom: 10px;
            }
            .back {
                color: #fff;
                font-size: 16px;
            }
        }
        .box{
            /*display: flex;*/
            /*flex-direction: row;*/
            /*flex-wrap: nowrap;*/
            /*justify-content: space-between;*/
            /*align-items: center;*/
            font-size:$TopSubFontSize;
            color:#000000;
            text-align:left;
            margin: 10px 0px;
            border-bottom:2px dotted #e7eaec;
            .boxContent{
                display: flex;
                justify-content: space-between;
                .level{
                    color: #7ED321;
                    font-size: 14px;
                    margin-bottom: 10px;
                    margin-top: 0;
                    margin-right: 20px;
                    .site{
                        color: #87909A;
                    }
                    .clientele{
                        color: #FF9901;
                        padding: 0 10px;
                    }
                    .clientele2{
                        color: #FF9901;
                        &:before {
                            display: inline-block;
                            content: '';
                            background: #FF9901;
                            height: $TopSubFontSize;
                            width: 1px;
                            margin: 0 20px;
                            vertical-align: top;
                            height: 14px;
                        }
                    }
                }
            }
            .dataStatus{
                font-size: 16px;
                color: #87909A;
                margin-bottom: 10px;
                margin-top: 5px;
                .clientele{
                    color: #FF9901;
                    padding: 0 10px;
                }
                .clientele2{
                    color: #ED3B3F;
                    padding: 0 10px;

                }
            }

        }
    }
</style>
<style>
    .hospital_ul li{
        margin-top: 5px;
    }
    .hospital_ul li:first-child{
        margin-top: 0px;
    }
</style>
<style scoped>
    #delete{
        color: #FFF;
        background-color: #ED3B3F;
        border-color: #ED3B3F;
    }
    #delete:hover{
        color: #FFF;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    .el-button{
        font-size: 13px;
    }
    .el-button--small {
        padding: 9px 12px;
    }
    .icon {
        height: 33px;
        position: relative;
        top: 3px;
        padding: 7px 12px;
    }
    .icon >>> span{
        position: relative;
        top: -2px;
    }
</style>




// WEBPACK FOOTER //
// src/components/hospitalBar.vue